export const SCHEDULE_PAGE_SIZE = 20;
